// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Wr39","emails":"CreateEditClinics_emails__3ehW_","emailTagLabel":"CreateEditClinics_emailTagLabel__mq6EU"};